<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection :text="(loading) ? `...` : `Estadísticas de ${data.goal.name}`" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<div class="card border-0 shadow-none" v-if="!loading">
				<div class="card-body vstack gap-8 px-0 vstack gap-5">
					<div class="table-responsive" v-for="period in data.periods" v-bind:key="period.id">
						<table class="table table-sm table-nowrap">
							<thead>
								<tr class="fw-bold">
									<td class="px-2 text-sm" width="150">{{ period.name }}</td>
									<td class="px-2 text-sm text-center" width="100">Nivel</td>
									<td class="px-2 text-sm text-center" width="100">Comisión</td>
									<td class="px-2 text-sm text-end" width="120">Monto</td>
									<td class="px-2 text-sm text-end" width="120">
										<span v-tooltip="'Venta media'">VM</span>
									</td>
									<td class="px-2 text-sm text-end" width="120">
										<span v-tooltip="'Descuento medio'">DM</span>
									</td>
									<td class="px-2 text-sm text-end" width="120">
										<span v-tooltip="'Producto medio'">PM</span>
									</td>
								</tr>
							</thead>
							<tbody>
								<template v-if="period.users.length > 0">
									<tr class="lh-sm align-top" v-for="user in period.users" v-bind:key="user.id">
										<td class="px-2 text-sm">{{ user.name }}</td>
										<td class="px-2 text-sm text-center">{{ (user.level.current_level !== undefined && user.level.current_level in data.goal.levels) ? data.goal.levels[user.level.current_level].name : '-' }}</td>
										<td class="px-2 text-sm text-center">{{ vueNumberFormat(((user.level.current_level !== undefined && user.level.current_level in data.goal.levels) ? data.goal.levels[user.level.current_level].commission : 0), { prefix: `% `, precision: 2 }) }}</td>
										<td class="px-2 text-sm text-end">{{ vueNumberFormat(user.amount, { suffix: ` ${data.goal.currency}`, precision: 2 }) }}</td>
										<td class="px-2 text-sm text-end">{{ vueNumberFormat(((user.sales !== 0) ? (user.amount / user.sales) : 0), { suffix: ` ${data.goal.currency}`, precision: 2 }) }}</td>
										<td class="px-2 text-sm text-end">{{ vueNumberFormat((((user.amount + user.discounts) !== 0) ? (user.discounts * 100 / (user.amount + user.discounts)) : 0), { suffix: ` %`, precision: 2 }) }}</td>
										<td class="px-2 text-sm text-end">{{ vueNumberFormat(((user.sales !== 0) ? (user.products / user.sales) : 0), { precision: 1 }) }}</td>
									</tr>
								</template>
								<template v-else>
									<tr>
										<td colspan="7" class="px-2 text-sm">No hay usuarios.</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import { ref, onBeforeMount } from 'vue';
	import router from '@/router';
	import composableForm from '@/composables/form';
	import CompanyAdminGoalRepository from '@/repositories/modules/Company/Admin/Goal';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const { loading, catchError } = composableForm();
			const data = ref({});

			onBeforeMount(async () => {
				await CompanyAdminGoalRepository.stat(props.id).then((response) => {
					data.value = response.data;
				}).catch((e) => {
					catchError(e);
					router.push({ name: `company.admin.goal.index` });
				});

				loading.value = false;
			});

			return { loading, data };
		}
	}
</script>